import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { SocialAuthService, FacebookLoginProvider, SocialUser } from '@abacritt/angularx-social-login';
import { Router} from '@angular/router';

declare var gapi: any;
@Component({
  selector: 'app-login-social',
  templateUrl: './login-social.component.html',
  styleUrls: ['./login-social.component.css']
})
export class LoginSocialComponent implements OnInit {

  errorMessage: string = '';
  isLoading: boolean = false;
  googleSignInError: string | null = null;

  st: 'email' | 'phone' | 'otp' | 'register' = 'email';

 constructor(
    private router: Router,
    private authService: AuthService,
    private socialAuthService: SocialAuthService

  ) {
  }


  ngOnInit(): void {
    if (this.router.url === '/login-pelanggan') {
      this.st ='email';    
    } else {
      this.st ='phone';             
    }    
  }


handleGoogleLogin() {
    const auth2 = gapi.auth2.getAuthInstance();
    auth2.signIn({
      prompt: 'consent',
      scope: 'openid email profile'
    }) // Memunculkan dialog untuk memilih akun
      .then((googleUser: any) => {
        // Memeriksa jika login berhasil
        if (googleUser) {
          // const profile = googleUser.getBasicProfile();
          const idToken = googleUser.getAuthResponse().id_token;
          // Jika perlu, bisa mengirim data ke server untuk proses login
          this.authService.loginWithGoogle(idToken).subscribe(
            (res) => {

              const dt = res.user;
                // Simpan data ke localStorage
                localStorage.setItem('authToken', idToken);  // Token untuk autentikasi
                localStorage.setItem('user_name', dt.nama);
                localStorage.setItem('user_email', dt.email);
                localStorage.setItem('user_photo', dt.foto);
                localStorage.setItem('user_login', 'google');
        
                // Menyimpan objek data pengguna untuk penggunaan lainnya
                localStorage.setItem('user_pelanggan', JSON.stringify({
                  name: dt.nama,
                  email: dt.emai,
                  photo: dt.foto
                }));

              // Redirect ke halaman utama setelah login sukses
               window.location.href = '/home';
            },
            (error) => {
              this.errorMessage = 'Failed to login with Google. Please try again.';
            }
          );
        } else {
          this.errorMessage = 'Google login was cancelled or failed. Please try again.';
        }
      })
      .catch((error: any) => {
        // Menangani jika pengguna membatalkan login atau terjadi kesalahan lainnya
        this.errorMessage = 'Google login was cancelled or failed. Please try again.';
      });
  }

  // =====================
  // Facebook Login
  // =====================
  loginWithFacebook(): void {
    this.socialAuthService.signIn(FacebookLoginProvider.PROVIDER_ID)
      .then(fbUser => {   
      // Kirim token Facebook ke backend untuk divalidasi
      this.authService.loginWithFacebook(fbUser.authToken).subscribe({
        next: (res) => {
          const dt = res.user;
          // Simpan data ke localStorage
          localStorage.setItem('authToken', fbUser.authToken);  // Token untuk autentikasi
          localStorage.setItem('user_name', dt.nama);
          localStorage.setItem('user_email', dt.email);
          localStorage.setItem('user_photo', dt.foto);
          localStorage.setItem('user_login', 'facebook');
  
          // Menyimpan objek data pengguna untuk penggunaan lainnya
          localStorage.setItem('user_pelanggan', JSON.stringify({
            name: dt.nama,
            email: dt.emai,
            photo: dt.foto
          }));
  
        // Redirect ke halaman utama setelah login sukses
          // Dapatkan rute asal
          const redirectUrl = this.authService.getRedirectUrl() || '/home'; // Default ke /dashboard jika tidak ada rute asal
          window.location.href = redirectUrl;

        },
        error: (err) => {
          console.error('Error login:', err);
        }
      });
    })
    .catch(err => {
      console.error('Error saat login Facebook:', err);
    });

  }

  switchToPhoneLogin() { 
      if (this.router.url === '/login-pelanggan') {
        setTimeout(() => {
          this.router.navigate(['/login-pelanggan/whatsapp']);
        }, 50);   
      } else {   
        setTimeout(() => {
          this.router.navigate(['/login-pelanggan']);
        }, 50);       
      }    
  }

  loginWithSocial(platform: 'facebook' | 'google' | 'whatsapp') {
    switch(platform) {
      case 'facebook':
        //  window.open('https://www.facebook.com/login', '_blank', 'width=600,height=700');
        this.loginWithFacebook();
        break;
      case 'google':
        this.handleGoogleLogin();
        break;
      case 'whatsapp':
        this.switchToPhoneLogin();
        break;
    }
  }
}
